import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderService } from './services';
import { SecondsToTimePipe } from './seconds-to-time.pipe';
import { ProgressBarComponent } from '../main-game/progress-bar/progress-bar.component';
import { CarouselComponent, CarouselItemElement } from '../carousel/carousel.component';
import { CarouselItemDirective } from '../carousel/carousel-item.directive';
import { ControllerService } from './services/controller.service';
import { HttpService } from './services/http.service';
import { LibraryButtonComponent } from './library-button/library-button.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { ReferencesService } from '../references.service';
import { HighlightSearchPipe } from './highlight-search.pipe';
import { KeysPipe } from './keys.pipe';
import { MessageModalComponent } from './message-modal/message-modal.component';

@NgModule({
  imports: [
    CommonModule,
    HighlightSearchPipe,
    KeysPipe
  ],
  declarations: [
    SecondsToTimePipe,
    ProgressBarComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    LibraryButtonComponent,
    BackButtonComponent,
    MessageModalComponent
  ],
  providers: [
    HeaderService,
    ControllerService,
    ReferencesService,
    HttpService
  ],
  exports: [
    CommonModule,
    SecondsToTimePipe,
    ProgressBarComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    LibraryButtonComponent,
    BackButtonComponent,
    HighlightSearchPipe,
    KeysPipe,
    MessageModalComponent
  ]
})
export class SharedModule {

}
